import { SubscriptionIntervalEnum } from '@systemeio/types'

export const SubscriptionIntervalTitles = {
  [SubscriptionIntervalEnum.year]: 'dashboard.name_of_times.years.one',
  [SubscriptionIntervalEnum.month]: 'dashboard.name_of_times.months.one',
  [SubscriptionIntervalEnum.week]: 'dashboard.name_of_times.weeks.one',
  [SubscriptionIntervalEnum.day]: 'dashboard.name_of_times.days.one',
}

export const SubscriptionIntervalTitlesIcu = {
  [SubscriptionIntervalEnum.year]: 'global.name_of_times.years_icu',
  [SubscriptionIntervalEnum.month]: 'global.name_of_times.months_icu',
  [SubscriptionIntervalEnum.week]: 'global.name_of_times.weeks_icu',
  [SubscriptionIntervalEnum.day]: 'global.name_of_times.day_icu',
}
